const locale = {
	home:"ホーム",
	my_profile:"個人設定",
	logout:"ログアウト",
	language: "言語",
	set_status:"ステータスを設定する",
	online:"オンライン",
	busy:"応答不可",
	absent:"退席中",
	invisible:"ログイン状態を隠す",
	search_project: '現場検索',
	closing_tab_will_logout: "SCAI タブが閉じます。 こちらにより、アカウントがログアウトされます。",
	select_project: '現場選択',
	session_history: 'セッション履歴',
	project_code: '工事コド:',
	english:'英語',
	japanese:'日本語',
};

export default locale;